export default "__VITE_ASSET__c9a69687__"